export const referenceKeys = {
  all: ["references"] as const,
  lists: () => [...referenceKeys.all, "list"] as const,
  details: () => [...referenceKeys.all, "detail"] as const,
  detail: (id: string) => [...referenceKeys.details(), id] as const,
}
